import { render } from "./TestReportSkinOsgame.vue?vue&type=template&id=6dc7b43a&scoped=true&ts=true"
import script from "./TestReportSkinOsgame.vue?vue&type=script&lang=ts"
export * from "./TestReportSkinOsgame.vue?vue&type=script&lang=ts"

import "./TestReportSkinOsgame.vue?vue&type=style&index=0&id=6dc7b43a&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc7b43a"]])

export default __exports__